fx.ns("shared.components", class CoverThumbSticker extends shared.components.CoverThumb 
{    
    constructor(parameters)
    {
        super(parameters);
    }

    load()
    {
        super.load();
        
        var sticker = this.model.stickers.find({id: this.data.content});
        if (!sticker)
            this.ready();
        else
            this.loadImage(sticker.light_url);
    }

    onImageLoaded()
    {                
        this.context.save();
        this.context.translate(this.elementX-this.offset, this.elementY);
        this.context.rotate(this.elementRotation*this.TO_RADIANS);
        this.context.translate(-(this.elementX-this.offset), -this.elementY);

        let scale = [1,1];
        let translate = [this.elementX , this.elementY];

        if (this.data.effectName.indexOf("h") > -1)
        {
            scale[0] = -1;
            translate[0] = this.elementX-this.offset+this.elementWidth;
        }
        if (this.data.effectName.indexOf("v") > -1)
        {
            scale[1] = -1;
            translate[0] = this.elementX-this.offset;
            translate[1] = this.elementY+this.elementHeight;
        }
        if (this.data.effectName.indexOf("h") > -1 && this.data.effectName.indexOf("v") > -1)
        {
            translate[0] = this.elementX-this.offset+this.elementWidth;
        }

        if(this.data.effectName.indexOf("h") > -1 || this.data.effectName.indexOf("v") > -1)
        {
            this.context.translate(translate[0], translate[1]);
            this.context.scale(scale[0],scale[1]);
            this.context.drawImage(this.image, 0, 0, this.elementWidth, this.elementHeight);
        }
        else
            this.context.drawImage(this.image, this.elementX-this.offset, this.elementY, this.elementWidth, this.elementHeight);
        
        this.context.restore();

        this.ready();
    }
});